import { Component, Input } from '@angular/core';
import { EventsEntity } from '../../../+state/events/models/events-entity';

@Component({
  selector: 'angular-community-event-row',
  templateUrl: './event-row.component.html',
  styleUrls: ['./event-row.component.scss'],
})
export class EventRowComponent {
  @Input() event: EventsEntity;
  @Input() isPastEvent: boolean;

  eventRSVPClicked(meetupId: string) {
    if (meetupId) {
      window.open(
        `https://www.meetup.com/AngularCommunity/events/${meetupId}`,
        '_blank'
      );
    }
  }

  eventWatchClicked(youtubeId: string) {
    if (youtubeId) {
      window.open(`https://youtu.be/${youtubeId}`, '_blank');
    }
  }
}
